import React from "react";
import styles from "./Tabs.module.scss";

interface TabsProps {
  active: number;
  setActive: (value: number) => void;
}

export default function Tabs({ active, setActive }: TabsProps) {
  return (
    <div className={styles.page}>
      <div
        className={`${styles.tab} ${active === 0 ? styles.active : ""}`}
        onClick={() => setActive(0)}
      >
        Detalhes
      </div>

      <div
        className={`${styles.tab} ${active === 1 ? styles.active : ""}`}
        onClick={() => setActive(1)}
      >
        Características
      </div>

      <div
        className={`${styles.tab} ${active === 2 ? styles.active : ""}`}
        onClick={() => setActive(2)}
      >
        Preço e Estoque
      </div>
    </div>
  );
}
